<template>
  <div class="downLoadCard">
    <div class="empty" v-if="materialQuery.length == 0">
      <el-empty description="暂无准考证信息"></el-empty>
    </div>
    <div v-if="materialQuery.length > 0" class="materialCard">
      <div class="iframeCard">
        <iframe
          id="documentIframe"
          border="0"
          :src="currentPdf"
          style="width: 100%; height: 100%; border: none"
        ></iframe>
      </div>
      <div class="materialList">
        <div
          v-for="(v, key) in materialQuery"
          :key="key"
          class="materialBox"
          :class="['materialBox', { active: activeIndex == key }]"
          @click="handleChangePdfFn(v, key)"
        >
          <div>{{ v.jobInfo }}</div>
          <div>{{ v.jobLevel }}</div>
          <div>{{ v.idCard }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { idCardInfoQuery } from "@/api/exam";
import to from "await-to";
// import { Base64 } from "js-base64";
export default {
  data() {
    return {
      idCard: this.$route.query.idCard || "",
      materialQuery: [],
      activeIndex: 0,
      currentPdf: "",
    };
  },
  mounted() {
    if (this.idCard) {
      this.handleGetUserMaterialsFn();
    }
  },
  methods: {
    async handleGetUserMaterialsFn() {
      const [res, err] = await to(idCardInfoQuery({ idCard: this.idCard }));
      if (err) return this.$message.warning(err.msg);
      this.materialQuery = res.data;
      if (this.materialQuery.length > 0) {
        this.currentPdf = this.materialQuery[0].url;
      }
    },
    handleChangePdfFn(v, k) {
      this.activeIndex = k;
      this.currentPdf = v.url;
    },
  },
};
</script>
<style lang="scss" scoped>
.downLoadCard {
  height: 100vh;
  .empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .materialCard {
    width: 1200px;
    margin: 0px auto;
    height: 100%;
    display: flex;
    .iframeCard {
      width: 950px;
      padding: 15px;
    }
    .materialList {
      flex-grow: 1;
      background: #f2f2f2;
      margin: 15px 10px;
      max-height: 100%;
      overflow-x: hidden;
      overflow-y: scroll;
      padding: 10px;
      .materialBox {
        background: #d7d7d7;
        margin-bottom: 20px;
        border-radius: 4px;
        padding: 10px;
        color: #333;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .active {
        background: #3671bf;
        margin-bottom: 20px;
        border-radius: 4px;
        padding: 10px;
        color: #fff;
      }
    }
    .materialList::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
